import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';
import { Carousel } from 'react-responsive-carousel';
import withStyles from '@mui/styles/withStyles';
import classNames from 'classnames';
import '../../packs/registration.css';
import mobileRecruitAppBg from '../../images/registrations/product_version/bg-04.png';
import recruitDashboardBg from '../../images/registrations/product_version/bg-05.png';
import eventManagementBg from '../../images/registrations/product_version/bg-06.png';
import interviewSchedulingBg from '../../images/registrations/product_version/bg-07.png';
import recruitingCrmBg from '../../images/registrations/product_version/bg-08.png';
import infoBg from '../../images/registrations/info_version/background.png';
import southernCoBg from '../../images/registrations/testimonial_version/bg-01.png';
import nationalGridBg from '../../images/registrations/testimonial_version/bg-02.png';
import wipfliBg from '../../images/registrations/testimonial_version/bg-03.png';
import SlideDesktopData from '../../shared/SlideDesktopData';

const styles = theme => ({
  mobileRecruitApp: { backgroundImage: `url(${mobileRecruitAppBg})` },
  recruitDashboard: { backgroundImage: `url(${recruitDashboardBg})` },
  eventManagement: { backgroundImage: `url(${eventManagementBg})` },
  interviewScheduling: { backgroundImage: `url(${interviewSchedulingBg})` },
  recruitingCrm: { backgroundImage: `url(${recruitingCrmBg})` },
  infoBg: { backgroundImage: `url(${infoBg})` },
  southernCoBg: { backgroundImage: `url(${southernCoBg})` },
  nationalGridBg: { backgroundImage: `url(${nationalGridBg})` },
  wipfliBg: { backgroundImage: `url(${wipfliBg})` },
  slideItems: {
    background: 'none !important',
    color: '#000 !important',
    opacity: '1 !important',
    top: '20px',
    '@media (min-width: 600px) and (max-width: 1024px) and (min-height: 1024px)': {
      top: '18%',
    },
  },
  testimonialItems: {
    background: '#fff !important',
    width: '70% !important',
    left: '60% !important',
    padding: '30px !important',
    [theme.breakpoints.up(1025)]: {
      top: '20% !important',
      bottom: '20% !important',
    },
    '@media (min-width: 600px) and (max-width: 1024px) and (min-height: 1024px)': {
      top: '28% !important',
      bottom: '28% !important',
    },
  },
  slideImages: { marginBottom: '15px' },
  customerAvaCss: {
    borderRadius: '100%',
    float: 'left',
    [theme.breakpoints.up(1025)]: {
      maxWidth: '90%',
    },
    [theme.breakpoints.down(undefined)]: {
      maxWidth: '100%',
    },
  },
  jobGrid: {
    [theme.breakpoints.up(1025)]: {
      padding: '15px 0px 0px 15px',
    },
    [theme.breakpoints.down(undefined)]: {
      paddingLeft: '15px',
    },
  },
  productImages: {
    '@media (min-width: 600px) and (max-width: 1024px) and (min-height: 1024px)': {
      width: '100% !important',
      marginBottom: theme.spacing(3),
    },
    width: '90% !important',
  },
  infoImages: {
    width: '55% !important',
    padding: '15px',
    marginTop: '15px',
    marginBottom: '15px',
  },
  southernCoImage: {
    [theme.breakpoints.up(1025)]: {
      width: '30% !important',
    },
    [theme.breakpoints.down(undefined)]: {
      width: '60% !important',
    },
    padding: '12px',
  },
  nationalGridImage: {
    [theme.breakpoints.up(1025)]: {
      width: '70% !important',
    },
    [theme.breakpoints.down(undefined)]: {
      width: '100% !important',
    },
    padding: '12px',
  },
  wipfliImage: {
    [theme.breakpoints.up(1025)]: {
      width: '50% !important',
    },
    [theme.breakpoints.down(undefined)]: {
      width: '100% !important',
    },
  },
  slideBackground: {
    backgroundSize: 'cover',
    height: window.innerHeight,
    backgroundPosition: 'center',
  },
  itemTitle: {
    marginBottom: '15px',
    [theme.breakpoints.up('lg')]: {
      marginBottom: theme.spacing(2),
    },
  },
  infoColor: { color: '#fff' },
  infoTitle: {
    marginTop: '20px',
    [theme.breakpoints.up('xl')]: {
      marginBottom: theme.spacing(3),
      marginTop: theme.spacing(5),
    },
  },
  questionTitle: { paddingTop: '10%' },
  itemDescription: { fontWeight: '300' },
});

const SlideDesktopVersion = (props) => {
  const { classes } = props;

  return (
    <Carousel
      showThumbs={false}
      showStatus={false}
      showIndicators
      showArrows={false}
      infiniteLoop
      stopOnHover={false}
      interval={6000}
      autoPlay
    >
      {SlideDesktopData.map(data => (
        <div
          className={
            classNames(classes[data.backgroundCss], classes.slideBackground)
          }
          key="Desktop Version"
        >
          <div className={
            classNames(classes.slideItems, classes[data.slideItem])
          }
          >
            <Typography
              component="h1"
              variant="h4"
              align="center"
              className={
                classNames(classes.itemTitle, classes.infoColor, classes.questionTitle)
              }
            >
              {data.question}
            </Typography>
            <img
              src={data.imageItem.url}
              alt={data.imageItem.alt}
              className={
                classNames(classes[data.imageCss], classes.slideImages)
              }
            />
            <Typography
              component="h1"
              variant="h4"
              align="center"
              className={
                classNames(classes.itemTitle, classes[data.colorWord], classes[data.titleCss])
              }
            >
              {data.title}
            </Typography>
            <Typography
              component="p"
              align="center"
              className={
                classNames(classes.itemDescription, classes[data.colorWord])
              }
            >
              {data.description.firstDes}
            </Typography>
            <Typography
              component="p"
              align="center"
              className={
                classNames(classes.itemDescription, classes[data.colorWord])
              }
            >
              {data.description.secondDes}
            </Typography>
          </div>
        </div>
      ))}
    </Carousel>
  );
};

SlideDesktopVersion.propTypes = {
  classes: PropTypes.instanceOf(Object).isRequired,
};

export default withStyles(styles)(SlideDesktopVersion);
